import { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router';
import CustomerService from 'services/customer';
import StoreSettingService from 'services/store_setting';
import { useApp } from 'contexts/app';
import _ from 'lodash';

const service = new CustomerService();
const storeSettingService = new StoreSettingService();

const useInfo = (customerId) => {
  const navigate = useNavigate();
  const { showLoading } = useApp();
  const [customer, setCustomer] = useState({});
  const [orders, setOrders] = useState([]);
  const [showCustomerEdit, setShowCustomerEdit] = useState(false);
  const [showCustomerLoginEdit, setShowCustomerLoginEdit] = useState(false);
  const [isAccountLoginMode, setIsAccountLoginMode] = useState(false);

  useEffect(() => {
    if (customerId) {
      loadData();
      loadLoginMethod();
    }
  }, [customerId]);

  const loadData = async () => {
    try {
      const cus = await service.getByID(customerId);
      if (cus) {
        setCustomer(cus);
        const newOrder = _.orderBy(cus.orders, ['create_on'], ['desc']);
        setOrders(newOrder);
      } else {
        setCustomer({});
        setOrders([]);
      }
    } catch (error) {
      console.error(error);
      setCustomer({});
      setOrders([]);
    }
  };

  const loadLoginMethod = async () => {
    try {
      const setting = await storeSettingService.getWebsiteSetting();
      setIsAccountLoginMode(setting?.login_method === 'account');
    } catch (error) {
      setIsAccountLoginMode(false);
    }
  };

  const onCustomerSave = async () => {
    await loadData();
  };

  const onNavigateOrder = (orderId) => {
    navigate(`/order/${orderId}`);
  };

  return {
    customer,
    orders,
    showCustomerEdit,
    showCustomerLoginEdit,
    isAccountLoginMode,
    setShowCustomerEdit,
    setShowCustomerLoginEdit,
    onCustomerSave,
    onNavigateOrder,
    loadData,
  };
};

export default useInfo;
